import { MapPin } from "lucide-react";

// Simplified Great Britain + Northern Ireland silhouette (equirectangular, lon -8.2..1.9, lat 49.9..58.8).
const GB = "M55,4 L60,3 L63,9 L61,15 L66,19 L64,26 L69,31 L67,37 L72,42 L78,44 L80,50 L76,56 L80,62 L77,69 L80,76 L86,79 L84,86 L78,90 L70,93 L63,92 L57,95 L48,96 L40,94 L36,89 L38,83 L44,79 L41,72 L45,66 L43,58 L47,52 L43,46 L46,39 L50,33 L46,27 L50,20 L48,13 L52,8 Z";
const NI = "M22,42 L31,40 L35,45 L33,52 L26,55 L20,50 Z";
const CITIES = {
  london: [51.51, -0.13], manchester: [53.48, -2.24], leeds: [53.8, -1.55], bristol: [51.45, -2.59], birmingham: [52.49, -1.9],
  liverpool: [53.41, -2.98], glasgow: [55.86, -4.25], edinburgh: [55.95, -3.19], cardiff: [51.48, -3.18], newcastle: [54.98, -1.61],
  sheffield: [53.38, -1.47], nottingham: [52.95, -1.15], belfast: [54.6, -5.93], brighton: [50.82, -0.14], oxford: [51.75, -1.26],
  cambridge: [52.2, 0.12], southampton: [50.9, -1.4], plymouth: [50.37, -4.14], york: [53.96, -1.08], leicester: [52.63, -1.13],
};
const project = ([lat, lon]) => ({ x: ((lon + 8.2) / 10.1) * 100, y: ((58.8 - lat) / 8.9) * 100 });

// UK silhouette with markers for the real top_locations; unmatched names still appear in the ranking.
export function UkLocationsMap({ locations, mapClass = "h-[136px] w-[84px]", numbered = false }) {
  if (!locations.length) return <p className="text-sm text-jigsaw-muted">No booking locations yet.</p>;
  const max = Math.max(...locations.map((l) => l.count));
  return (
    <div className="flex gap-4">
      <svg viewBox="0 0 100 100" data-testid="uk-map" className={`${mapClass} shrink-0`} aria-label="UK booking locations">
        <path d={GB} fill="#E8ECF3" stroke="#D0D7E3" strokeWidth="0.8" />
        <path d={NI} fill="#E8ECF3" stroke="#D0D7E3" strokeWidth="0.8" />
        {locations.map((l) => {
          const c = CITIES[l.location.toLowerCase()];
          if (!c) return null;
          const { x, y } = project(c);
          const r = 2.5 + (l.count / max) * 4;
          return <g key={l.location}><circle cx={x} cy={y} r={r} fill="#F28C28" opacity="0.9" /><circle cx={x} cy={y} r={r + 2.5} fill="#F28C28" opacity="0.2" /></g>;
        })}
      </svg>
      <ol className={`min-w-0 flex-1 text-sm ${numbered ? "divide-y divide-jigsaw-border" : "space-y-1.5"}`}>
        {locations.slice(0, 5).map((l, i) => (
          <li key={l.location} className={`flex items-center justify-between gap-2 ${numbered ? "py-[7px]" : ""}`}>
            <span className="flex min-w-0 items-center gap-2 text-jigsaw-navy">
              {numbered ? <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-jigsaw-bg text-[11px] font-semibold text-jigsaw-muted">{i + 1}</span>
                : <><span className="w-3 text-xs text-jigsaw-muted">{i + 1}</span><MapPin className="h-3.5 w-3.5 shrink-0 text-jigsaw-orange" /></>}
              <span className="truncate text-[13px]">{l.location}</span></span>
            <span className={`font-mono-ref ${numbered ? "font-semibold text-jigsaw-navy" : "text-jigsaw-muted"}`}>{l.count}</span>
          </li>
        ))}
      </ol>
    </div>
  );
}
